module.exports = __webpack_public_path__ + "img/canarias.4d3c9892.png";